/*
 * Copyright (c) Dito Technologies
 */

import React, {Dispatch} from "react";
import Stepper from "ui/kit/stepper/Stepper";
import styles from "./RootStepper.module.scss";
import {Action, SelectStepAction, State, StepType} from "ui/feature/root/FormReducer";
import UseRootStepper from "ui/feature/root/UseRootStepper";

interface Props {
    state: State
    dispatch: Dispatch<Action>
}

const RootStepper: React.FC<Props> = ({state, dispatch}) => {

    const steps = UseRootStepper(state)

    const stepClicked = React.useCallback((step: number) => {
        const action: SelectStepAction = {
            type: "select_step",
            step: step as StepType
        }
        dispatch(action);
    }, [dispatch])

    return (
        <div className={styles.container}>
            <Stepper stepClicked={stepClicked} items={steps}/>
        </div>
    )
}

export default RootStepper;